import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';

if (process.env.VUE_APP_STAGING === '1') {
  Vue.config.devtools = true;
}

const requireModule = require.context('./modules', false, /\.ts$/);
const modules = {};

requireModule.keys().forEach((fileName) => {
  if (fileName === './index.js') return;
  // filter fullstops and extension
  // and return a camel-case name for the file
  const moduleName = fileName.replace('Module', '').replace(/(\.\/|\.ts)/g, '');
  // create a dynamic object with all modules
  modules[moduleName] = {
    // add namespace here
    namespaced: true,
    ...requireModule(fileName).default,
    // if you have exported the object with name in the module `js` file
    // e.g., export const name = {};
    // uncomment this line and comment the above
    // ...requireModule(fileName)[moduleName]
  };
});

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
    version: '1.0.0', // a simple property
    mode: process.env.VUE_APP_STAGING === '1' ? 'staging' : 'production',
    reload: 0,
    loading: false,
    loadingCount: 0,
    snackbar: {
      show: false,
      type: 'info',
      message: '',
    },
    rateLimitException: false,
    rateLimitRetryAfter: 0,
    swUpdateCheckCount: 0,
    dialog: null,
    // TODO: need to apply this state to all the existing dialog events
    globalDialog: {
      show: false,
      content: '',
      width: 600,
    },
    showAlert: !localStorage.getItem('hide_alert'),
  },
  getters: {
    getTimezones() {
      return require('@/data/Timezones.json');
    },
  },
  actions: {
    callAction({ commit }, payload) {
      commit('CALL_ACTION', payload);
    },
  },
  mutations: {
    RELOAD_ROUTER_VIEW(state) {
      state.reload++;
    },
    SET_LOADING(state, isLoading) {
      if (isLoading) {
        state.loadingCount++;
        state.loading = isLoading;
      } else if (state.loadingCount > 0) {
        state.loadingCount--;
        state.loading = state.loadingCount > 0;
      }
    },
    SET_SNACKBAR(state, snackbar) {
      state.snackbar = snackbar;
    },
    SET_RATE_LIMIT_EXCEPTION(state, payload) {
      state.rateLimitException = payload;
    },
    SET_RATE_LIMIT_RETRY_AFTER(state, payload) {
      state.rateLimitRetryAfter = payload;
    },
    CALL_ACTION() {
      //
    },
    SW_UPDATE_INVOKED(state) {
      state.swUpdateCheckCount++;
    },
    OPEN_DIALOG(state, payload) {
      state.dialog = payload;
    },
    CLOSE_DIALOG(state) {
      state.dialog = null;
    },
    SET_GLOBAL_DIALOG(state, payload) {
      state.globalDialog = {
        ...state.globalDialog,
        ...payload,
      };
    },
    SET_SHOW_ALERT(state, payload) {
      localStorage.setItem('hide_alert', (!!payload).toString());
      state.showAlert = payload;
    },
  },
  modules,
};

export default new Vuex.Store<RootState>(store);
